import React from 'react';
import { safeHTML } from '../../../../utils/safeHTML';
import Toggle from '../../../baseComponents/gui/toggle/Toggle';
import { shopContent } from '../../../../constants/copyright';
import { useTranslation } from '../../../../translations';
const { title } = shopContent;

const ShopHeader = React.forwardRef(function ShopHeader({ setters, toggle }, ref) {
  const { t } = useTranslation();

  return (
    <>
      <h2 className={'shop__title'}>{safeHTML(t(title))}</h2>
      <div className={'shop__tabs'}>
        <Toggle list={toggle} funcs={setters} />
      </div>
    </>
  );
});

export default ShopHeader;
ShopHeader.propTypes = {};
